import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { installationAPI } from '../api/installation';
import { toast } from 'react-toastify';
import './Installations.css';

const Installations = () => {
  const [installations, setInstallations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filteredInstallations, setFilteredInstallations] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10
  });

  useEffect(() => {
    fetchInstallations();
  }, [pagination.page]);

  useEffect(() => {
    filterInstallations();
  }, [searchQuery, installations]);

  const fetchInstallations = async () => {
    try {
      setLoading(true);
      const response = await installationAPI.getAll(pagination.page, pagination.limit);
      console.log(response.data);
      setInstallations(response.data);
      setPagination(prev => ({
        ...prev,
        ...response.pagination
      }));
    } catch (error) {
      toast.error('Failed to fetch installations');
    } finally {
      setLoading(false);
    }
  };

  const filterInstallations = () => {
    if (!searchQuery.trim()) {
      setFilteredInstallations(installations);
      return;
    }

    const query = searchQuery.toLowerCase();
    const filtered = installations.filter(installation =>
      installation.installationName?.toLowerCase().includes(query) ||
      installation.name?.toLowerCase().includes(query)
    );
    setFilteredInstallations(filtered);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

   const clearSearch = () => {
    setSearchQuery('');
  };


  const handleDelete = async (uniqueId, name) => {
    if (!window.confirm(`Are you sure you want to delete "${name}"?`)) {
      return;
    }

    try {
      await installationAPI.delete(uniqueId);
      toast.success('Installation deleted successfully');
      fetchInstallations();
    } catch (error) {
      toast.error('Failed to delete installation');
    }
  };

  const copyUniqueId = (uniqueId) => {
    navigator.clipboard.writeText(uniqueId);
    toast.success('Unique ID copied to clipboard');
  };

  if (loading) {
    return <div className="installations-page">Loading...</div>;
  }

  return (
    <div className="installations-page">
      <div className="page-header">
        <h1>Installations</h1>
        
        <div className="search-bar">
            <div className="search-input-wrapper">
              <span className="search-icon">🔍</span>
              <input
                type="text"
                className="search-input"
                placeholder="Search by installation name..."
                value={searchQuery}
                onChange={handleSearchChange}
              />
              {searchQuery && (
                <button className="clear-search" onClick={clearSearch} title="Clear search">
                  ✕
                </button>
              )}
            </div>
            {searchQuery && (
              <div className="search-results-info">
                Found {filteredInstallations.length} of {installations.length} installations
              </div>
            )}
          </div>
          <Link to="/installations/create" className="btn btn-success">
          + Create Installation
        </Link>
      </div>

      {filteredInstallations.length === 0 ? (
        <div className="empty-state">
          <p>No installations found</p>
          <Link to="/installations/create" className="btn btn-success">
            Create First Installation
          </Link>
        </div>
      ) : (
        <>
          <div className="table-container">
            <table className="installations-table">
              <thead>
                <tr>
                  <th>Name/Unique ID</th>
                  <th>Status/Last Sync</th>
                  <th>Computer</th>
                  {/* <th>Description</th> */}
                  <th>Backup Configs</th>
                  {/* <th></th> */}
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredInstallations.map((installation) => (
                  <tr key={installation.uniqueId}>
                    <td className="name-cell">
                      <strong>{installation.installationName}</strong>
                      <div className="unique-id-display">
                        <code>{installation.uniqueId}</code>
                        <button
                          onClick={() => copyUniqueId(installation.uniqueId)}
                          className="btn-copy"
                          title="Copy Unique ID"
                        >
                          📋
                        </button>
                      </div>
                    </td>
                    <td>
                      <span className={`status ${installation.isActive ? 'active' : 'inactive'}`}>
                        {installation.isActive ? 'Active' : 'Inactive'}
                      </span><br/>
                      {installation.lastSyncedAt 
                        ? new Date(installation.lastSyncedAt).toLocaleString()
                        : 'Never'}
                    </td>
                    <td>{installation.computerName || '-'}</td>
                    {/* <td className="description-cell">
                      {installation.description || '-'}
                    </td> */}
                    <td className="center-text">
                      {installation.backupConfigCount || 0}
                    </td>
                    <td className="actions-cell">
                      <div className="action-buttons">
                        <Link
                          to={`/installations/${installation.uniqueId}`}
                          className="btn btn-primary btn-sm"
                          title="View Details"
                        >
                          View
                        </Link>
                        <Link
                          to={`/installations/edit/${installation.uniqueId}`}
                          className="btn btn-secondary btn-sm"
                          title="Edit"
                        >
                          Edit
                        </Link>
                        <button
                          onClick={() => handleDelete(installation.uniqueId, installation.installationName)}
                          className="btn btn-danger btn-sm"
                          title="Delete"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {pagination.totalPages > 1 && (
            <div className="pagination">
              <button
                onClick={() => setPagination(prev => ({ ...prev, page: prev.page - 1 }))}
                disabled={pagination.page === 1}
                className="btn btn-secondary"
              >
                Previous
              </button>
              <span>
                Page {pagination.page} of {pagination.totalPages}
              </span>
              <button
                onClick={() => setPagination(prev => ({ ...prev, page: prev.page + 1 }))}
                disabled={pagination.page === pagination.totalPages}
                className="btn btn-secondary"
              >
                Next
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Installations;